import { useEffect } from 'react';

const useFocusElementOnExit = (element: HTMLElement | null | undefined) => {
    useEffect(() => {
        return () => {
            if (element) {
                element.tabIndex = -1;
                element.focus();
            }
        };
    }, [element]);
};

export default useFocusElementOnExit;
